import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PartnerFullModel, RequestParams, ResponseCatalog } from 'Models'
import { UserModel } from 'Pages/user'
import { Id } from 'Src/types/aliases'
import { Callback } from 'Types/utilTypes'

type UserState = {
	requestParams: RequestParams
	users: ResponseCatalog<UserModel>
	user: UserModel
	partner: PartnerFullModel
}

const initialState: UserState = {
	requestParams: new RequestParams(),
	users: new ResponseCatalog<UserModel>(),
	user: null,
	partner: null,
}

export namespace UserNS {
	export type GetAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetAll = PayloadAction<ResponseCatalog<UserModel>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type GetOne = PayloadAction<{
		id: Id
		updateGrid?: boolean
		callback?: Callback
	}>
	export type SetOne = PayloadAction<UserModel>
	export type GetPartner = PayloadAction<string>
	export type SetPartner = PayloadAction<PartnerFullModel>
	export type SetOneInGrid = PayloadAction<UserModel>
	export type UpdateOne = PayloadAction<{
		id: Id
		data: UserModel
		updateGrid?: boolean
		callback?: Callback
	}>
	export type DeleteOne = PayloadAction<{
		id: Id
		callback?: Callback
	}>
	export type ResetToken = PayloadAction<{
		id: Id
		callback?: Callback
	}>
	export type ResendToken = PayloadAction<{
		id: Id
		callback?: Callback
	}>
	export type ResetPassword = PayloadAction<{
		id: Id
		callback?: Callback
	}>
	export type CompleteLeadSocket = PayloadAction
}

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		getAll: (state, action: UserNS.GetAll) => {},
		setAll: (state, action: UserNS.SetAll) => {
			state.users = action.payload
		},
		setRequestParams: (state, action: UserNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			return initialState
		},
		getOne: (state, action: UserNS.GetOne) => {},
		setOne: (state, action: UserNS.SetOne) => {
			state.user = action.payload
		},
		getPartner: (state, action: UserNS.GetPartner) => {},
		setPartner: (state, action: UserNS.SetPartner) => {
			state.partner = action.payload
		},
		clearPartner: (state) => {
			state.partner = null
		},
		setOneInGrid: (state, action: UserNS.SetOneInGrid) => {
			const findIndex = state.users.entries.findIndex((user) => user.id === action.payload.id)
			if (findIndex !== -1) {
				state.users.entries[findIndex] = action.payload
			}
		},
		updateOne: (state, action: UserNS.UpdateOne) => {},
		deleteOne: (state, action: UserNS.DeleteOne) => {},
		resetToken: (state, action: UserNS.ResetToken) => {},
		resendToken: (state, action: UserNS.ResendToken) => {},
		resetPassword: (state, action: UserNS.ResetPassword) => {},
		completeLeadSocket: (state, action: UserNS.CompleteLeadSocket) => {},
	},
})
